import React from 'react'
import NewsItem from '../Components/News/NewsItem'

function News() {
  return (
    <div className='newsContainer'>
      <div className='newsdiv'>
      <NewsItem/>
      <NewsItem/>
      <NewsItem/>
      <NewsItem/>
      <NewsItem/>
      <NewsItem/>
      <NewsItem/>
      <NewsItem/>
      </div>

    </div>
  )
}

export default News
